import { createStyles, IconButton, makeStyles, Theme, Typography } from '@material-ui/core';
import * as React from 'react';

import { combine } from '../calendarPicker.utils';

interface Props {
  filled?: boolean;
  outlined?: boolean;
  highlighted?: boolean;
  disabled?: boolean;
  startOfRange?: boolean;
  endOfRange?: boolean;
  onClick?: () => void;
  onHover?: () => void;
  value: number | string;
}

const CalendarPickerDay: React.FC<Props> = (props) => {
  const classes = useStyles();

  return (
    <div
      className={combine(
        classes.buttonContainer,
        props.startOfRange && classes.leftBorderRadius,
        props.endOfRange && classes.rightBorderRadius,
        !props.disabled && props.highlighted && classes.highlighted,
      )}
    >
      <IconButton
        className={combine(
          classes.button,
          !props.disabled && props.outlined && classes.outlined,
          !props.disabled && props.filled && classes.filled,
        )}
        disabled={props.disabled}
        onClick={props.onClick}
        onMouseOver={props.onHover}
      >
        <Typography
          className={combine(
            classes.buttonText,
            props.disabled && classes.textDisabled,
            !props.disabled && classes.textEnabled,
            !props.disabled && props.filled && classes.contrast,
          )}
          variant="body2"
        >
          {props.value}
        </Typography>
      </IconButton>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    leftBorderRadius: {
      borderRadius: '50% 0 0 50%',
    },
    rightBorderRadius: {
      borderRadius: '0 50% 50% 0',
    },
    buttonContainer: {
      display: 'flex',
    },
    button: {
      height: 36,
      width: 36,
      padding: 0,
    },
    buttonText: {
      lineHeight: 1.6,
    },
    textEnabled: {
      color: theme.palette.text.primary,
    },
    textDisabled: {
      color: theme.palette.secondary.main,
    },
    outlined: {
      border: `1px solid ${theme.palette.primary.main}`,
    },
    filled: {
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
      },
      backgroundColor: theme.palette.primary.main,
    },
    highlighted: {
      backgroundColor: theme.palette.action.hover,
    },
    contrast: {
      color: theme.palette.primary.contrastText,
    },
  }),
);

export default CalendarPickerDay;
